// Legacy/typo URL: /services → /digital-marketing (301).
// Common WordPress-era path; consolidates link equity onto canonical hub.
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/services")({
  beforeLoad: () => {
    throw redirect({ to: "/digital-marketing", statusCode: 301 });
  },
});
